import React from 'react';
import { Dropdown, Tooltip, Button } from 'antd';
import { FontSizeOutlined, CheckOutlined } from '@ant-design/icons';
import { useTheme } from '@/App';
import { defaultColors } from '@/themes/antd-theme';

const SCALES = [
  { label: 'Small', value: 'sm' },
  { label: 'Medium', value: 'md' },
  { label: 'Large', value: 'lg' },
  { label: 'Extra Large', value: 'xl' },
];

export default function FontSizeToggle() {
  const { fontScale, setFontScale, isDark } = useTheme();

  const bgColor = isDark ? defaultColors.grey[700] : defaultColors.grey[100];
  const iconColor = isDark ? defaultColors.grey[100] : defaultColors.grey[700];

  const items = SCALES.map(({ label, value }) => ({
    key: value,
    label: (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minWidth: 110 }}>
        <CheckOutlined style={{ visibility: value === fontScale ? 'visible' : 'hidden', fontSize: 12 }} />
        {label}
      </span>
    ),
  }));

  return (
    <Tooltip title="Font size" placement="bottom" zIndex={9999}>
      <Dropdown
        trigger={['click']}
        menu={{
          items,
          selectable: true,
          selectedKeys: [fontScale],
          onClick: ({ key }) => setFontScale(key),
        }}
        placement="bottomRight"
      >
        <Button
          type="text"
          shape="circle"
          icon={<FontSizeOutlined style={{ fontSize: 18, color: iconColor }} />}
          aria-label="Font size"
          style={{
            backgroundColor: bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
          className="transition-all duration-300"
        />
      </Dropdown>
    </Tooltip>
  );
}
